var _rect, _path, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBalleriniDevs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.49353,
    width: 10.3881,
    height: 41.5979,
    rx: 5.19404,
    fill: "#6FCF97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0371 17.9619C15.0371 15.3517 17.1531 13.2357 19.7633 13.2357V13.2357C22.3735 13.2357 24.4894 15.3517 24.4894 17.9619V28.582C24.4894 31.1922 22.3735 33.3082 19.7633 33.3082V33.3082C17.1531 33.3082 15.0371 31.1922 15.0371 28.582V17.9619Z",
    fill: "#27AE60"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0371,
    y: 1.89084,
    width: 9.45234,
    height: 10.0362,
    rx: 4.72617,
    fill: "#27AE60"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8174,
    y: 15.5574,
    width: 9.45234,
    height: 10.0362,
    rx: 4.72617,
    fill: "#6FCF97"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBalleriniDevs);
export default __webpack_public_path__ + "static/media/logo_ballerini_devs.fc05fcc667a0275127dc67d4f3d8bc18.svg";
export { ForwardRef as ReactComponent };